var map = {
	"./usb-a-gold.svg": 45,
	"./usb-a-silver.svg": 46,
	"./usb-c-gold.svg": 47,
	"./usb-c-silver.svg": 48,
	"./usb-mini-gold.svg": 49,
	"./usb-mini-silver.svg": 50
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 11;